import {
  ListItemText as MuiListItemText,
  type ListItemTextProps as MuiListItemTextProps,
} from '@mui/material';

/**
 * Props for configuring a card menu item text component from [MicroLibraryCoreUI](https://dev.azure.com/orcha/MicroLibraryTemplate/_git/MicroLibraryCoreUI)
 *
 * @property {MuiListItemTextProps} props - The props for the list item text.
 */
export const CardMenuItemText = ({ ...props }: MuiListItemTextProps) => {
  return (
    <MuiListItemText
      primaryTypographyProps={{
        sx: {
          fontSize: '14px',
          fontWeight: '500',
        },
      }}
      {...props}
    />
  );
};
